// calendarview.style.js
// Csak a ténylegesen használt stílusok maradnak, minden mást törlünk

export const sxConfig = {
  eventTime: {
    fontWeight: 'bold',
    fontSize: '0.9rem',
  },
  eventTitle: {
    fontSize: '1.05rem',
    ml: 0.5,
  },
  eventIconBox: {
    display: 'inline-block',
    verticalAlign: 'middle',
    px: 0.5,
  },
  eventBox: {
    p: 0.35,
    overflow: 'hidden',
    width: '100%',
    //borderRadius: 1,
  },
};
